import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NoContentStubComponent } from '@frontendlib/components/components/no-content-stub/no-content-stub.component';
import { LinkInfoFileComponent } from '@modules/elements/components/link-info/link-info-file/link-info-file.component';
import { ElementsModule } from '@modules/elements/elements.module';
import { FormControlsModule } from '@modules/form-controls/form-controls.module';
import { UtilsModule } from '@modules/utils/utils.module';
import { AttachmentsComponent } from './components/attachments/attachments.component';

@NgModule({
  imports: [
    CommonModule,
    FormControlsModule,
    UtilsModule,
    MatIconModule,
    ElementsModule,
    MatTooltipModule,
    LinkInfoFileComponent,
    NoContentStubComponent,
  ],
  declarations: [AttachmentsComponent],
  exports: [AttachmentsComponent],
  // `AttachmentsService` is deliberately NOT provided here: a module-provided service holds the ROOT
  // `HttpClient`, which carries no spaces interceptor, so its requests can never name a mailbox tenant
  // (#971). It is provided by the `[spaceContext]` injector instead — see `space-context.directive.ts`.
})
export class AttachmentsModule {}
